<template>
	<editor
		:show.sync="editorVisible"
		title="充值"
		:data-model-name="dataModelName"
		:fields="editorFields"
		:default-value="form"
		@submit="doSubmit"
		:check-ever-edited="false"
		:use-submit-event="true"
		v-if="editorVisible"
	>
	<div slot="info" class="col-12">
		<h4 class="text-bold">{{userInfo.name}} [{{userInfo.phone}}]</h4>
		<div class="tips mb-3" >当前余额：{{userInfo.balance}}</div>
	</div>
	</editor>
</template>

<script>

export default {
	data() {
		return {
			dataModelName: "Balanceflow",
			form: {
				customer: { _id:"",name:""}
			},
			
			editorFields: [
				{
					name: "pay_type",
					col: 6,
					params:{
						showEnums:['0','2']
					}
				},
				{
					name: "pay_method",
					col: 6,
					rules: ["required"],
					params:{
						showEnums:['10','11','20','21','30','40','50']
					}
				},
				{
					name: "payed_at",
					col: 6,
					rules: ["required"],
					params:{
						type:'ts'
					}
				},
				{
					name: "total_get",
					col: 6,
					rules: ["required"],
				},
				{
					name: "desc",
					col: 12,
					width: "100%",
					params: {
						rows: 5
					}
				},
				{
					name: "primary_img",
					col: 12,
					rules: ["required"],
				}
			],
			loadings: {
				main: false
			},
		};
	},
	computed: {
		editorVisible: {
			get: function() {
				return this.show;
			},
			set: function(val) {
				this.$emit("update:show", val);
			}
		},
	},
	created() {
		this.form.customer = JSON.parse(JSON.stringify(this.userInfo));
	},
	mounted() {},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		recordId: {
			type: String,
			default: ""
		},
		userInfo:{
			type: Object,
			default: function() {
				return {};
			},
		}
	},
	methods: {
		doChange() {
			this.$message({
				type: "success",
				message: "充值成功!"
			});
			this.loadings.main = false;
			this.$emit("tab", "history");
			this.$router.push({
				name: "Customer-Agent",
				params: {
					tab: "history"
				}
			});
		},
		doSubmit(data) {
			this.loadings.main = true;
			data.customer = {
				_id : this.recordId
			};

			this.$axios
				.post("/customer/do_charge/", data)
				.then(json => {
					this.$message({
						type: "success",
						message: "充值成功!"
					});
					this.loadings.main = false;
					this.$emit("change", json.data);
					this.editorVisible = false;
				})
				.catch(json => {
					this.loadings.main = false;
					if (this.err[json.data.field]) {
						this.err[json.data.field] = json.data.msg;
					}
					this.$message({
						message: json.data.msg,
						type: "error"
					});
				});
		}
	},
	watch: {},
};
</script>
<style lang="scss" scoped>
</style>
